import { Route } from '@angular/router';
import { RouteGuard } from '../auth/route.guard';

const tierRoutes: Route[] = [
  {
    path: 'tier',
    loadChildren: () => import('./tier/tier.module').then((m) => m.TierModule),
    canActivate: [RouteGuard],
  },
];

export default tierRoutes;
